import { number_from_currency } from './procurement_compliance_helpers';

function value_or_default(value, fallback_value) {
  const resolved_value = value || fallback_value;
  return resolved_value;
}

function drawer_check(label, ok) {
  const status = ok ? 'Pass' : 'Fail';
  const check_class = ok ? 'is-pass' : 'is-fail';
  const drawer_check_item = { label, status, class: check_class };
  return drawer_check_item;
}

function drawer_evidence(title, ok) {
  const subtitle = ok ? 'On file' : 'Missing - gap for audit';
  const evidence_class = ok ? 'is-pass' : 'is-fail';
  const evidence_item = { title, subtitle, class: evidence_class };
  return evidence_item;
}

function requisition_summary(row) {
  const summary = [
    { label: 'Value', value: row.value },
    { label: 'Threshold band', value: row.threshold },
    { label: 'Supplier', value: row.supplier || '-', badge: { label: row.eligibility.label, class: row.eligibility.class } },
    { label: 'Stage', value: row.stage || 'Review' }
  ];
  return summary;
}

function requisition_checklist(row) {
  const checklist = [
    drawer_check('Need & budget confirmed', true),
    drawer_check('Correct method for threshold', true),
    drawer_check('Minimum quotes / tender obtained', row.status.label !== 'Pending'),
    drawer_check('Supplier eligible (tax, CSD, BBBEE)', row.eligibility.label === 'Eligible'),
    drawer_check('No irregular-expenditure flag', row.status.label !== 'Irregular')
  ];
  return checklist;
}

function requisition_evidence_pack(row) {
  const evidence_pack = [
    drawer_evidence('Requisition & budget approval', true),
    drawer_evidence('Quotations / tender responses', true),
    drawer_evidence('Evaluation & scoring sheet', true),
    drawer_evidence('Supplier eligibility (CSD / tax / BBBEE)', row.eligibility.label === 'Eligible'),
    drawer_evidence('Award approval', true)
  ];
  return evidence_pack;
}

export function create_requisition_drawer_from_row(row) {
  if (row.drawer) return row.drawer;
  const subtitle = `${number_from_currency(row.value)} - ${value_or_default(row.method, 'Single quote')}`;
  const compliance_note = value_or_default(row.note, 'Compliance review in progress.');
  const requisition_drawer = {
    row_id: row.id,
    kicker: `REQUISITION - ${row.id} - ${String(row.dept || '').toUpperCase()}`,
    title: row.requisition,
    subtitle,
    status: { label: row.status.label, class: row.status.class },
    summary: requisition_summary(row),
    checklist: requisition_checklist(row),
    evidence_pack: requisition_evidence_pack(row),
    compliance_note,
    link_label: 'Open supplier in register'
  };
  return requisition_drawer;
}
